/* template */
<template><page><div :class='["cube-radio-group-page"]'><base-container><view-desc>单选 - 未禁用</view-desc><div :class='["radio-group-item"]'><cube-radio-group></cube-radio-group></div><view-desc>单选 - 控制一行显示个数</view-desc><div :class='["radio-group-item"]'><cube-radio-group-column-num></cube-radio-group-column-num></div><view-desc>单选 - 禁用</view-desc><div :class='["radio-group-item"]'><cube-radio-group-disabled></cube-radio-group-disabled></div><view-desc>单选 - 行内样式</view-desc><div :class='["radio-group-item"]'><cube-radio-group-inline></cube-radio-group-inline></div><view-desc>单选 - 使用slot</view-desc><div :class='["radio-group-item"]'><cube-radio-group-slot></cube-radio-group-slot></div></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_1e902d5b"}'>
.cube-radio-group-page
  height 100%
  background-color rgba(239, 239, 244, .7)
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1e902d5b"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1e902d5b"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1e902d5b"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {"styleIsolation":"shared"},
    // @ts-ignore
    componentsMap: {'cube-radio-group-slot':getComponent(require("./group-slot.mpx?isComponent&outputPath=components%2Fgroup-slot5372fa5e%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio-group':getComponent(require("./group.mpx?isComponent&outputPath=components%2Fgroup136546f0%2Findex")),'cube-radio-group-disabled':getComponent(require("./group-disabled.mpx?isComponent&outputPath=components%2Fgroup-disabled34808362%2Findex")),'cube-radio-group-inline':getComponent(require("./group-inline.mpx?isComponent&outputPath=components%2Fgroup-inline290a7a28%2Findex")),'cube-radio-group-column-num':getComponent(require("./group-column-num.mpx?isComponent&outputPath=components%2Fgroup-column-num0e7767e2%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>